import { toIdValue } from 'apollo-utilities';
import { withClientState } from 'apollo-link-state';
import { defaultDataIdFromObject } from 'apollo-cache-inmemory';
export function fragmentCacheRedirect(dataIdFromObject) {
    if (dataIdFromObject === void 0) { dataIdFromObject = defaultDataIdFromObject; }
    return {
        getFragment: function (_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return toIdValue(dataIdFromObject({ __typename: __typename, id: id }));
        },
    };
}
export function fragmentLinkState(apolloCache) {
    return withClientState({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function (_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({ __typename: __typename, id: id });
                    return cache.data.data[fragmentId];
                },
            },
        },
    });
}
//# sourceMappingURL=index.js.map